import { Process } from 'shared/domain/process/types/model';

export function isBelowSuperAdminPermission(
  permissions: UserPermissionDto
): permissions is BelowSuperAdminPermission {
  return (permissions as BelowSuperAdminPermission).clients !== undefined;
}

export enum UserRole {
  visible_no_access = 'visible_no_access',
  standard = 'standard',
  manager = 'manager',
  viewer = 'viewer',
  projectAdmin = 'admin',
  organizationAdmin = 'clientadmin',
  superAdmin = 'superadmin',
}

// it't not possible to create superadmin
export type CreatableUserRole =
  | UserRole.visible_no_access
  | UserRole.standard
  | UserRole.viewer
  | UserRole.manager
  | UserRole.projectAdmin
  | UserRole.organizationAdmin;

enum PaidOrFree {
  free = 'free',
  paid = 'paid',
}

export const USER_ROLE_PRICING_LABEL_ID: Record<UserRole, PaidOrFree> = {
  [UserRole.visible_no_access]: PaidOrFree.free,
  [UserRole.standard]: PaidOrFree.free,
  [UserRole.manager]: PaidOrFree.paid,
  [UserRole.viewer]: PaidOrFree.paid,
  [UserRole.projectAdmin]: PaidOrFree.paid,
  [UserRole.organizationAdmin]: PaidOrFree.paid,
  [UserRole.superAdmin]: PaidOrFree.paid,
};

interface StandardManagerOrViewerProjectPermission {
  role: UserRole.standard | UserRole.viewer | UserRole.manager;
  // project id
  _id: string;
  processes: Process[];
  sites: string[];
}

interface VisibleWithNoAccessProjectPermission {
  role: UserRole.visible_no_access;
  // project id
  _id: string;
  processes: never;
  sites: never;
}

interface ProjectAdminPermission {
  role: UserRole.projectAdmin;
  // project id
  _id: string;
  processes: never;
  sites: never;
}

type PermissionOnProject =
  | ProjectAdminPermission
  | StandardManagerOrViewerProjectPermission
  | VisibleWithNoAccessProjectPermission;

export interface BelowOrganizationAdminPermission {
  projects: PermissionOnProject[];
  role?: never;
  // organization id
  _id: string;
}

interface OrganizationAdminPermission {
  role: UserRole.organizationAdmin;
  projects: never;
  // organization id
  _id: string;
}

type PermissionOnOrganization =
  | OrganizationAdminPermission
  | BelowOrganizationAdminPermission;

interface SuperAdminPermission {
  role: UserRole.superAdmin;
}

interface BelowSuperAdminPermission {
  clients: PermissionOnOrganization[];
  role?: never;
}

export type UserPermissionDto =
  | SuperAdminPermission
  | BelowSuperAdminPermission;
